
<template>

  <footer>

    <div :class="{ 'mt-8 sm:mt-16': $slots.logo }">
      
      <slot name="logo"></slot>

    </div>

    <div class="bg-blue-primary px-6 py-16 sm:px-8 lg:px-24" :class="[ $slots.logo && $slots.note ? 'sm:py-28' : '' ]">

      <div class="max-w-6xl mx-auto">

        <h2 class="font-bold text-white text-center" :class="[ $slots.logo && $slots.note ? 'mb-12' : 'mb-4' ]">PIONEERING DIAGNOSTICS</h2>

        <div class="max-w-5xl mx-auto text-xs text-white text-center">

          <slot name="note"></slot>

          <p>

            &copy;<span data-use-full-year></span> bioMérieux, Inc. 
            
            <span class="font-extrabold">&middot; </span>  
            
            <a class="underline" href="https://www.biomerieux.com/us/en/service-and-support/patents.html">Patents</a> 
            
            <span class="font-extrabold"> &middot;</span> 
            
            515 Colorow Drive, Salt Lake City, UT 84108 
            
            <span class="font-extrabold">&middot;</span> 
            
            Tel: <a href="tel:+18006347656">(800) 634-7656</a>

            <span class="font-extrabold"> &middot; </span>
            
            <a class="underline" href="https://www.biomerieux.com/us/en/privacy/protection-of-personal-information-and-commitment-to-privacy.html">Privacy Policy</a>
            
            <span class="font-extrabold"> &middot;</span> 
            
            BMX.1.168991
            
            <span class="font-extrabold">&middot;</span> 
            
            Rev01.A.

          </p>

        </div>

      </div>

    </div>

  </footer>

</template>